import {Button, Form, FormFeedback, FormGroup, Input, Label} from "reactstrap";
import {useContext, useState} from "react";
import {useMutation} from "@tanstack/react-query";
import {passwordChange} from "../../api/api";
import {toast} from "react-toastify";
import handleUnauthorized401MutateError from "../../utils/handleUnauthorized401MutateError";
import AuthContext from "../../context/AuthContext";
import Loader from "../../components/Loader";
import {useNavigate} from "react-router-dom";

function PasswordChangeTab({redirectOnSuccess = null}) {
    const {refreshToken, setUser} = useContext(AuthContext)
    const [currentPassword, setCurrentPassword] = useState('')
    const [newPassword, setNewPassword] = useState('')
    const [confirmNewPassword, setConfirmNewPassword] = useState('')
    const navigate = useNavigate()

    const passwordChangeMutation = useMutation({
        mutationFn: passwordChange,
        onSuccess: (data, variables) =>{
            setUser((currentUser) => currentUser ? {...currentUser, must_change_password: false} : currentUser)
            setCurrentPassword('')
            setNewPassword('')
            setConfirmNewPassword('')
            toast.success('Password Changed!')
            if (redirectOnSuccess) {
                navigate(redirectOnSuccess)
            }
        },
        // onError: err => {
        //     toast.error(`An error occurred! ${err?.response?.data?.detail}`)
        // }
        onError: (err, variables) => {
            handleUnauthorized401MutateError(err, refreshToken, passwordChangeMutation, variables)
            if(err.response.status !== 401){
                toast.error(`An error occurred! ${err?.response?.data?.detail}`)
            }
        }
    })

    const handleChangePassword = (e) =>{
        e.preventDefault();
        const formData = new FormData();
        formData.append("current_password", currentPassword);
        formData.append("new_password1", newPassword);
        formData.append("new_password2", confirmNewPassword);
        passwordChangeMutation.mutate(formData)
    }


    return (
        <>
            <div className="row">
                <div className="col-12">
                    <div className="p-2">
                        <Form onSubmit={handleChangePassword} className="form-horizontal">

                            <FormGroup className="form-group row">
                                <Label for="current-password" className="col-sm-2 col-form-label">Current Password
                                    <span className="text-danger">*</span>
                                </Label>
                                <div className="col-sm-10">
                                    <Input
                                        id="current-password"
                                        type="password"
                                        placeholder="Current Password"
                                        onChange={(e) =>
                                            setCurrentPassword(
                                                e.target.value
                                            )
                                        }
                                        value={currentPassword}
                                        invalid={
                                            passwordChangeMutation.isError && passwordChangeMutation.error.response.data.current_password
                                        }
                                    />
                                    {passwordChangeMutation.isError && passwordChangeMutation.error.response.data.current_password && (
                                        <FormFeedback invalid>
                                            {passwordChangeMutation.error.response.data.current_password}
                                        </FormFeedback>
                                    )}
                                </div>
                            </FormGroup>
                            <FormGroup className="form-group row">
                                <Label for="new-password" className="col-sm-2 col-form-label">New Password
                                    <span className="text-danger">*</span>
                                </Label>
                                <div className="col-sm-10">
                                    <Input
                                        id="new-password"
                                        type="password"
                                        placeholder="New Password"
                                        onChange={(e) =>
                                            setNewPassword(
                                                e.target.value
                                            )
                                        }
                                        value={newPassword}
                                        invalid={
                                            passwordChangeMutation.isError && passwordChangeMutation.error.response.data.new_password1
                                        }
                                    />
                                    {passwordChangeMutation.isError && passwordChangeMutation.error.response.data.new_password1 && (
                                        <FormFeedback invalid>
                                            {passwordChangeMutation.error.response.data.new_password1}
                                        </FormFeedback>
                                    )}
                                </div>
                            </FormGroup>
                            <FormGroup className="form-group row">
                                <Label for="confirm-new-password" className="col-sm-2 col-form-label">Confirm New Password
                                    <span className="text-danger">*</span>
                                </Label>
                                <div className="col-sm-10">
                                    <Input
                                        id="confirm-new-password"
                                        type="password"
                                        placeholder="Confirm New Password"
                                        onChange={(e) =>
                                            setConfirmNewPassword(
                                                e.target.value
                                            )
                                        }
                                        value={confirmNewPassword}
                                        invalid={
                                            passwordChangeMutation.isError && passwordChangeMutation.error.response.data.new_password2
                                        }
                                    />
                                    {passwordChangeMutation.isError && passwordChangeMutation.error.response.data.new_password2 && (
                                        <FormFeedback invalid>
                                            {passwordChangeMutation.error.response.data.new_password2}
                                        </FormFeedback>
                                    )}
                                </div>
                            </FormGroup>

                            <FormGroup className="form-group mb-0 justify-content-end row">
                                <div className="col-sm-10">
                                    <Button type="submit"
                                            className="btn bx-btn-primary waves-effect waves-light"
                                            disabled={(!currentPassword && !newPassword && !confirmNewPassword) || passwordChangeMutation.isLoading}
                                    >
                                        {passwordChangeMutation.isLoading? <><Loader size={'small'}/>Changing Password...</>: `Change Password`}
                                    </Button>
                                </div>
                            </FormGroup>
                        </Form>
                    </div>
                </div>
            </div>
        </>
    );
}

export default PasswordChangeTab;
